// 日期      版本      維護人員     修改原因
// 20220830  v01.00    Jasper       初版
// 20220908  v02.00    Jasper       支援WIN 與 MAC
// 20220912  v03.00    Jasper       增加 DecryptPdf、ShowPdf、SavePdf、DeletePdf
// 20220919  v04.00    Jasper       調整版號判斷條件GetAgentVersion
// 20230712  v05.00    Jasper       新增clear_token function
// 20230719  v06.00    HaoYu        新增GetCardSerial, GetBasicData, SelectCertUI function
// 20230829  v07.00    HaoYu        change alert to console.log
// 20230830  v08.00    HaoYu        更改Exception整合問題
// 20240301  v09.00    HaoYu        新增HCA

var pk11SessionToken = null;

var TWCA_ERROR_AGENT_NOT_FOUND = 10001;
var TWCA_ERROR_AGENT_VERSION = 10002;

function initPk11AgentForChrome(beginPort=49100, detectVersion_WIN=["1.1.0.0"], detectVersion_MAC=["1.1.0.0"]) {
    //=========客戶設定初始化參數 起=========

    // var beginPort = port; //元件PORT(例:99999)
    var TWCA_URL = "" //API URL (例:URL: 1.空值(new) 2./TWCA  3./TWCA?)
    var Pk11ATL = "Pkcs11ATL";// 舊版元件DLL(例:TaiFexCapiATL.dll)

    //中介元件區分WIN版與MAC版號
    // var detectVersion_WIN = ["1.1.0.0"]; // WIN(最後一個為最新版號)
    // var detectVersion_MAC = ["1.1.0.0"]; // MAC(最後一個為最新版號)

    //=========客戶設定初始化參數 迄=========

    var newPk11ATL = "PKCS11"; // 新版元件URL
    var port = beginPort; //初始PORT
    var obj = null;
    var currentVersion = 0; //現行版號 currentVersion
    var isNewAgent = true;
    var isNewAPI = false;
    if ((navigator.userAgent.indexOf("Chrome") > 1) ||
        (navigator.userAgent.indexOf("Trident") > 1) ||
        (navigator.userAgent.indexOf("Firefox") > 1) ||
        (navigator.userAgent.indexOf("Safari") > 1)) {
        obj = {
            getDetectVersion: function(str) {
                if (obj.isMacOS()) {
                    return detectVersion_MAC
                } else {
                    return detectVersion_WIN
                }
            },
            clear_token: function() { // 8
                pk11SessionToken = null;
                return obj.ParseInt("||0||0||"); // 返回整數值
            },
            init_data: function(i_beginPort, i_Pk11ATL, i_detectVersion_WIN, i_detectVersion_MAC, i_TWCA_URL) {
                beginPort = i_beginPort;
                Pk11ATL = i_Pk11ATL;
                detectVersion_WIN = i_detectVersion_WIN;
                detectVersion_MAC = i_detectVersion_MAC;
                TWCA_URL = i_TWCA_URL
                pk11SessionToken = null;
            },
            send: function(str) {
                var xhr = new XMLHttpRequest();
                var resp;
                var j = 60; // fix Safari Exception, total 600 sec.
                if (pk11SessionToken != null) {
                    try {
                        try {
                            var URL = "https://localhost:" + port + TWCA_URL; // 現在使用寫法
                            xhr.open("POST", URL, false);
                            xhr.send(str); // 現在使用寫法
                            resp = xhr.responseText;
                            //新舊並行POST 錯 再試GET
                            var res = resp.substring(1, 5);
                            if (res == "|-1|" || resp == "(null)") {
                                throw new Exception();
                            }
                        } catch (err) {
                            try {
                                str = (TWCA_URL.indexOf('?') != -1) ? str : "?" + str;
                                var URL = "https://localhost:" + port + TWCA_URL + str; // 現在使用寫法
                                xhr.open("POST", URL, false);
                                xhr.send(null); // 現在使用寫法
                                resp = xhr.responseText;
                            } catch (err) {
                                resp = "||" + TWCA_ERROR_AGENT_NOT_FOUND + "||Win send Exception||";
                            }
                        }

                    } catch (err) {
                        if (obj.isMacOS() == true) {
                            while (j > 0) {
                                try {
                                    xhr.open("POST", "https://localhost:" + port + TWCA_URL, false); // 未來新版寫法
                                    xhr.send("retry"); // 未來新版寫法
                                    resp = xhr.responseText;
                                    break;
                                } catch (err) {
                                    j = j - 1;
                                    if (j == 0) console.log("operation timeout");
                                }
                            }
                        } else {
                            resp = "||" + TWCA_ERROR_AGENT_NOT_FOUND + "||Mac send Exception||";
                        }
                    } // fix Safari Exception, total 600 sec.
                }
                return resp;
            },
            sendInitDll: function(thisPort, str) {
                var xhr = new XMLHttpRequest();
                var resp;
                try {
                    var URL = "https://localhost:" + thisPort + TWCA_URL; // 未來新版寫法
                    xhr.open("POST", URL, false);
                    xhr.send(str); // 未來新版寫法
                    resp = xhr.responseText;
                    //新舊並行POST 錯 再試GET
                    var res = resp.substring(1, 5);
                    if (res == "|-1|" || resp == "(null)") {
                        throw new Exception();
                    }
                } catch (err) {
                    try {
                        str = (TWCA_URL.indexOf('?') != -1) ? str : "?" + str;
                        var URL = "https://localhost:" + thisPort + TWCA_URL + str; // 未來新版寫法
                        xhr.open("POST", URL, false);
                        xhr.send(null); // 未來新版寫法
                        resp = xhr.responseText;
                    } catch (err) {
                        resp = "||" + TWCA_ERROR_AGENT_NOT_FOUND + "||Win send Exception||";
                    }
                }
                var res = resp.substring(1, 4);
                if (res == "|0|") {
                    port = thisPort;
                }
                return resp;
            },
            initChrome: function() {
                var resp;
                if (pk11SessionToken == null) {
                    var thisPort;
                    for (i = 0; i < 3; i++) {
                        thisPort = beginPort + i;
                        try { // 先試 新版功能
                            var str = obj.sendInitDll(thisPort, "InitDLL=" + newPk11ATL);
                            pk11SessionToken = obj.ParseReturnNoAlert(str);
                            if (pk11SessionToken != null && pk11SessionToken != "") {
                                isNewAPI = true;
                            } else {
                                var str = obj.sendInitDll(thisPort, "InitDLL=" + Pk11ATL);
                                pk11SessionToken = obj.ParseReturn(str);
                            }
                        } catch (err) { // 舊版功能
                        }
                        if (pk11SessionToken != null) {
                            break;
                        }
                    }
                }

                if (pk11SessionToken == null) {
                    //throw new Exception("中介程式錯誤版號"); //
                    resp = TWCA_ERROR_AGENT_NOT_FOUND;
                }

                // 再增加版本判斷
                if (pk11SessionToken != null) {
                    currentVersion = obj.GetAgentVersion();
                    var detected = false;
                    detectVersion = detectVersion_WIN.concat(detectVersion_MAC)
                    // 逐一偵測版號
                    for (var i = 0; i < detectVersion.length; i++) {
                        var thisVersion = detectVersion[i];
                        if (currentVersion == thisVersion) {
                            // 版號正確
                            detected = true;
                            break;
                        }
                    }
                    if (detected == false) {
                        //throw new Exception("中介程式錯誤版號"); //
                        resp = TWCA_ERROR_AGENT_VERSION;
                    } else {
                        resp = 0;
                    }

                }
                return resp;
            },
            initChromeAsync: function(callbackfun) {
                var promiseList = [];
                var thisPort = beginPort;
                var postObj = {
                    method: "POST"
                };
                // Cmx: Missing_CSP_Header 誤判
                postObj["bo"+"dy"] = "InitDLL=" + Pk11ATL;
                for (i = 0; i < 3; i++) {
                    promiseList[i] = fetch("https://localhost:" + thisPort + TWCA_URL, postObj);
                    thisPort = thisPort + 1;
                }
                Promise
                    .allSettled(promiseList)
                    .then(response => {
                        let reject = !response.some((v) => {
                            return v.status == 'fulfilled'
                        })

                        if (reject) {
                            callbackfun(TWCA_ERROR_AGENT_NOT_FOUND);
                        } else {
                            response.forEach(function(item, index) {
                                // console.log(item, index);
                                if (item.status == "fulfilled") {
                                    const url = new URL(item.value.url);
                                    // console.log("success port " + url.port);
                                    port = url.port;
                                    item.value.text().then(function(text) {
                                        pk11SessionToken = obj.ParseReturn(text);
                                        // console.log(text);

                                        // 再增加版本判斷
                                        if (pk11SessionToken != null) {
                                            var resp;
                                            currentVersion = obj.GetAgentVersion();
                                            var detected = false;
                                            detectVersion = detectVersion_WIN.concat(detectVersion_MAC)
                                            // 逐一偵測版號
                                            for (var i = 0; i < detectVersion.length; i++) {
                                                var thisVersion = detectVersion[i];
                                                if (currentVersion == thisVersion) {
                                                    // 版號正確
                                                    detected = true;
                                                    break;
                                                }
                                            }
                                            if (detected == false) {
                                                resp = TWCA_ERROR_AGENT_VERSION;
                                            } else {
                                                resp = 0;
                                            }
                                            callbackfun(resp);
                                        }
                                    });

                                }
                            });
                        }
                    });
            },
            isMacOS: function() {
                return navigator.platform.indexOf('Mac') > -1;
            },
            ExecMethod: function(apiName) {
                return "DLLToken=" + pk11SessionToken + "&ExecMethod=" + apiName; // 全部內容注意大小寫
            },
            ExecParam: function() {
                var ret = "";
                for (var i = 0; i < arguments.length; i++) {
                    ret += "&Param" + (i + 1) + "=" + encodeURIComponent(arguments[i]);
                }
                return ret; // 全部參數注意大小寫
            },
            ParseReturnNoAlert: function(result) { // 不顯示警告訊息
                if (result == null) {
                    return null;
                }
                var res = result.split("||");
                if (parseInt(res[1]) == 0) {
                    return res[2];
                } else {
                    //alert("執行失敗, 錯誤訊息 = " + res[2]);
                    return null;
                }
            },
            ParseReturn: function(result) {
                var res = result.split("||");
                if (parseInt(res[1]) == 0) {
                    return res[2];
                } else {
                    console.log("執行失敗, 錯誤訊息 = " + res[2]);
                    return null;
                }
            },
            ParseInt: function(result) {
                var res = result.split("||");
                if (parseInt(res[1]) == 0) {
                    return parseInt(res[2]);
                } else {
                    console.log("執行失敗, 錯誤訊息 = " + res[2]);
                    return res[1];
                }
            },
            GetAgentVersion: function() { // 中介程式版本

                if (currentVersion == 0) {
                    var resp = ""
                    try {
                        var str = obj.ExecMethod("GetAgentVersion"); // 取得 中介程式 版號
                        resp = obj.send(str);
                        var res = resp.substring(1, 5);
                        if (res == "|-1|" || res == "|500") {
                            throw new Exception();
                        }

                    } catch (err) {
                        try {
                            var str = obj.ExecMethod("GetVersion"); // 取得 中介程式 版號
                            resp = obj.send(str);
                            var res = resp.substring(1, 5);
                            if (res == "|-1|" || res == "|500") {
                                throw new Exception();
                            }

                        } catch (err) {
                            var str = obj.ExecMethod("GetDLLVersion"); // 取得 中介程式 版號
                            resp = obj.send(str);
                        }
                    }
                    if (pk11SessionToken != null) return obj.ParseReturn(resp)
                }
                if (pk11SessionToken != null) return currentVersion
            },
            // 基本功能(版本/錯誤碼/返回值)
            GetErrorCode: function() { // 1
                var str = obj.ExecMethod("GetErrorCode"); // DLL 內部的正確名稱
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            GetErrorMsg: function() { // 2
                var str = obj.ExecMethod("GetErrorMsg");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetVersion: function() { // 3
                return obj.GetAgentVersion();
            },
            GetDLLVersion: function() { // 3
                return obj.GetAgentVersion();
            },
            // PKCS11
            SetTokenType: function(type) { // 4
                var str = obj.ExecMethod("SetTokenType") + obj.ExecParam(type);
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            SetTokenType2: function(type) { // 9 : long SetTokenType2(long cardType)
                var str = obj.ExecMethod("SetTokenType2") + obj.ExecParam(type);
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str));
            },
            GetCardType: function() { // 5

                try {

                    var str = obj.ExecMethod("GetCardType"); // 取得 中介程式 版號
                    resp = obj.send(str);
                    var res = resp.substring(1, 5);
                    if (res == "|-1|") {
                        throw new Exception();
                    }

                } catch (err) {

                    var str = obj.ExecMethod("GetCardType2"); // 取得 中介程式 版號
                    resp = obj.send(str);
                    var res = resp.substring(1, 5);
                    //if (res == "|-1|") {
                    //	throw new Exception("GetCardType 錯誤");
                    //}

                }
                if (pk11SessionToken != null) return obj.ParseReturn(resp)
            },

            GetCardStatus: function() { // 6
                var str = obj.ExecMethod("GetCardStatus");
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            Login: function(PINCode, PfxPath) { // 7
                var str = obj.ExecMethod("Login") + obj.ExecParam(PINCode, PfxPath);
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            LoginUI: function(cb) { //
                var str = obj.ExecMethod("LoginUI") + obj.ExecParam();
                if (pk11SessionToken != null)
                    if (cb != null) {
                        obj.send(str, function(txt) { cb(obj.ParseReturn(txt)); });
                    } else {
                        // 沒有 cb, 執行原路
                        return obj.ParseInt(obj.send(str));
                    }
            },
            SelectCertUI: function(CertType) { //
                var str = obj.ExecMethod("SelectCertUI") + obj.ExecParam(CertType);
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            ChangePin: function(oldPin, newPin) {
                var str = obj.ExecMethod("ChangePin") + obj.ExecParam(oldPin, newPin);
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str));
            },
            GetBasicData: function() {
                var str = obj.ExecMethod("GetBasicData") + obj.ExecParam();
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            Logout: function() { // 8
                var str = obj.ExecMethod("Logout");
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            GetCardSerial: function() {
                var str = obj.ExecMethod("GetCardSerial");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            SelectCert: function(CertType) { // 9
                var str = obj.ExecMethod("SelectCert") + obj.ExecParam(CertType);
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            GetHiCertType: function() { // 10
                var str = obj.ExecMethod("GetHiCertType");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetHiCertTailCitizenID: function() { // 11
                var str = obj.ExecMethod("GetHiCertTailCitizenID");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetHiCertUniformOrganizationID: function() { // 12
                var str = obj.ExecMethod("GetHiCertUniformOrganizationID");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetCardPriSec: function() { // 13
                var str = obj.ExecMethod("GetCardPriSec");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetGPKICardNo: function() { // 14
                var str = obj.ExecMethod("GetGPKICardNo");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            readGPKIUserData: function(l_uchptrUserPIN, l_uchptrSNO) { // 15
                var str = obj.ExecMethod("readGPKIUserData") + obj.ExecParam(l_uchptrUserPIN, l_uchptrSNO);
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            getGPKIUserData: function() { // 16
                var str = obj.ExecMethod("getGPKIUserData");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            // XCA 支援
            GetHiCertCaName: function() { // 17
                var str = obj.ExecMethod("GetHiCertCaName");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetHiCertSubjectTypeCht: function() { // 18
                var str = obj.ExecMethod("GetHiCertSubjectTypeCht");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetHiCertSubjectTypeEng: function() { // 19
                var str = obj.ExecMethod("GetHiCertSubjectTypeEng");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetHiCertEntityOID: function() { // 20
                var str = obj.ExecMethod("GetHiCertEntityOID");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            // Hash 處理
            Hash: function(Hashdata, type) { // 21
                var str = obj.ExecMethod("Hash") + obj.ExecParam(Hashdata, type);
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            HashFile: function(toFilePath, type) { // 22
                var str = obj.ExecMethod("HashFile") + obj.ExecParam(toFilePath, type);
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            GetHashedData: function() { // 23
                var str = obj.ExecMethod("GetHashedData");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            // PKCS1/PKCS7 簽章處理
            SignPKCS7: function(toSigndata) { // 24
                var str = obj.ExecMethod("SignPKCS7") + obj.ExecParam(toSigndata);
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            DecryptPdf: function(encryptedB64, flag) { // 50
                var str = obj.ExecMethod("DecryptPdf") + obj.ExecParam(encryptedB64, flag);
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            ShowPdf: function() { // 51
                var str = obj.ExecMethod("ShowPdf");
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            SavePdf: function() { //
                var str = obj.ExecMethod("SavePdf");
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            DeletePdf: function() { // 52
                var str = obj.ExecMethod("DeletePdf");
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            SignPKCS7UTF8: function(toSigndata) { // 25
                var str = obj.ExecMethod("SignPKCS7UTF8") + obj.ExecParam(toSigndata);
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            SignPKCS7ByFile: function(toSignFilePath) { // 26
                var str = obj.ExecMethod("SignPKCS7ByFile") + obj.ExecParam(toSignFilePath);
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            SignPKCS7ByBigFile: function(toSignFilePath) { // 27
                var str = obj.ExecMethod("SignPKCS7ByBigFile") + obj.ExecParam(toSignFilePath);
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            GetPKCS7Data: function() { // 28
                var str = obj.ExecMethod("GetPKCS7Data");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            SignPKCS1: function(toSigndata) { // 29
                var str = obj.ExecMethod("SignPKCS1") + obj.ExecParam(toSigndata);
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            GetPKCS1SignData: function() { // 25
                return obj.GetPKCS1Data();
            },
            GetPKCS1Data: function() { // 30
                try {
                    var str = obj.ExecMethod("GetPKCS1Data");
                    result = obj.send(str);
                    var res = result.substring(1, 5);
                    if (res == "|-1|") {
                        throw new Exception();
                    }
                } catch (err) {
                    var str = obj.ExecMethod("GetPKCS1SignData");
                    result = obj.send(str);
                }
                if (pk11SessionToken != null) return obj.ParseReturn(result);
            },
            VerifyPKCS7: function(toVerifyData) { // 31
                var str = obj.ExecMethod("VerifyPKCS7") + obj.ExecParam(toVerifyData);
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            GetVerifiedContent: function() { // 32
                var str = obj.ExecMethod("GetVerifiedContent");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetVerifiedCertB64: function() { // 33
                var str = obj.ExecMethod("GetVerifiedCertB64");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetVerifiedCertSerial: function() { // 34
                var str = obj.ExecMethod("GetVerifiedCertSerial");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetVerifiedCertSubject: function() { // 35
                var str = obj.ExecMethod("GetVerifiedCertSubject");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetVerifiedCertIssuer: function() { // 36
                var str = obj.ExecMethod("GetVerifiedCertIssuer");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetVerifiedCertNotBefore: function() { // 37
                var str = obj.ExecMethod("GetVerifiedCertNotBefore");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetVerifiedCertNotAfter: function() { // 38
                var str = obj.ExecMethod("GetVerifiedCertNotAfter");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            SignPkcs1Hashed: function(toHashedB64, dwFlags) { //
                var str = obj.ExecMethod("SignPkcs1Hashed") + obj.ExecParam(toHashedB64, dwFlags);
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            SignPKCS1ByFile: function(path) { //
                var str = obj.ExecMethod("SignPKCS1ByFile") + obj.ExecParam(path);
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str));
            },
            // 憑證返回值
            GetCertFinger: function() { // 39
                try {
                    //證券
                    var str = obj.ExecMethod("GetSelectedCertFinger");
                    result = obj.send(str);
                    var res = result.substring(1, 5);
                    if (res == "|-1|") {
                        throw new Exception();
                    }

                } catch (err) {
                    //銀行
                    var str = obj.ExecMethod("GetCertFinger");
                    result = obj.send(str);
                }
                if (pk11SessionToken != null) return obj.ParseReturn(result);
            },
            GetSelectedCertFinger: function() { // 39
                return obj.GetCertFinger();
            },

            GetSelectedCertB64: function() { // 40
                var str = obj.ExecMethod("GetSelectedCertB64");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetSelectedCertSerial: function() { // 41
                var str = obj.ExecMethod("GetSelectedCertSerial");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetSelectedCertSubject: function() { // 42
                var str = obj.ExecMethod("GetSelectedCertSubject");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetSelectedCertIssuer: function() { // 43
                var str = obj.ExecMethod("GetSelectedCertIssuer");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetSelectedCertNotBefore: function() { // 44
                var str = obj.ExecMethod("GetSelectedCertNotBefore");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetSelectedCertNotAfter: function() { // 45
                var str = obj.ExecMethod("GetSelectedCertNotAfter");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            // 加解密處理
            CertEncrypt: function(Base64Cert, EncryptData) { // 46
                var str = obj.ExecMethod("CertEncrypt") + obj.ExecParam(Base64Cert, EncryptData);
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            GetCertEncryptedData: function() { // 47
                var str = obj.ExecMethod("GetCertEncryptedData");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            SymEncrypt: function(Key, Data) { // 48
                var str = obj.ExecMethod("SymEncrypt") + obj.ExecParam(Key, Data);
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            SymDecrypt: function(Key, Base64Data) { // 49
                var str = obj.ExecMethod("SymDecrypt") + obj.ExecParam(Key, Base64Data);
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            GetSymEncryptedData: function() { // 50
                var str = obj.ExecMethod("GetSymEncryptedData");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetSymDecryptedData: function() { // 51
                var str = obj.ExecMethod("GetSymDecryptedData");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            //雙向認證(一)
            GetServerAuth: function() { // 52 雙向認證
                var str = obj.ExecMethod("GetServerAuth");
                result = obj.send(str);
                if (pk11SessionToken != null) return obj.ParseReturn(result);
            },
            VerifyServerResponse: function(strServerResponse) { // 53 雙向認證
                var str = obj.ExecMethod("VerifyServerResponse") + obj.ExecParam(strServerResponse);
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            //雙向認證(二)
            GenAuthenCode: function() { // long GenAuthenCode();
                var str = obj.ExecMethod("GenAuthenCode");
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            GetAuthenCodeData: function() { // CString GetAuthenCodeData();
                var str = obj.ExecMethod("GetAuthenCodeData");
                result = obj.send(str);
                if (pk11SessionToken != null) return obj.ParseReturn(result);
            },
            CheckAuthenResponse: function(authenCheckRes) {
                var str = obj.ExecMethod("CheckAuthenResponse") + obj.ExecParam(authenCheckRes);
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            GetAuthenState: function() { // long GetAuthenState();
                var str = obj.ExecMethod("GetAuthenState");
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },

            // 終止 ATLAgent
            finalizeAgent: function() {
                if (pk11SessionToken != null) obj.send(obj.ExecMethod("Logout"));
                var str = obj.ExecMethod("finalizeAgent");
                if (pk11SessionToken != null) obj.send(str);
                pk11SessionToken = null;
            },


            //憑證申請流程
            MakePKCS10: function(keyType, keySize, cn) { // 38 : long MakePKCS10(long keyType, long keySize, BSTR cn)
                var str = obj.ExecMethod("MakePKCS10") + obj.ExecParam(keyType, keySize, cn);
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str));
            },
            GetBase64CSR: function() { // 39 : BSTR GetBase64CSR()
                var str = obj.ExecMethod("GetBase64CSR");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetBase64MAC: function() { // 40 : BSTR GetBase64MAC()
                var str = obj.ExecMethod("GetBase64MAC");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            ImportCert: function(b64X509, b64MAC) { // 41 : long ImportCert(BSTR b64X509, BSTR b64MAC)
                var str = obj.ExecMethod("ImportCert") + obj.ExecParam(b64X509, b64MAC);
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str));
            },
            AcceptPKCS7: function(strPkcs7, dwFlag) { //
                var str = obj.ExecMethod("AcceptPKCS7") + obj.ExecParam(strPkcs7, dwFlag);
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str));
            },
            ClearExpiredCert: function() { //
                var str = obj.ExecMethod("ClearExpiredCert") + obj.ExecParam();
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str));
            },

            //TWCA Car
            GetTWCAPKICardInfo: function() { // 26 : long GetTWCAPKICardInfo()
                var str = obj.ExecMethod("GetTWCAPKICardInfo");
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str));
            },
            GetTWCACardSN: function() { // 27 : BSTR GetTWCACardSN()
                var str = obj.ExecMethod("GetTWCACardSN");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetTWCACardType: function() { // 28 : BSTR GetTWCACardType()
                var str = obj.ExecMethod("GetTWCACardType");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetGPKICardNo: function() { // 29 : BSTR GetGPKICardNo()
                var str = obj.ExecMethod("GetGPKICardNo");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetHiCertType: function() { // 30 : BSTR GetHiCertType()
                var str = obj.ExecMethod("GetHiCertType");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetCardPriSec: function() { // 31 : BSTR GetCardPriSec()
                var str = obj.ExecMethod("GetCardPriSec");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetHiCertTailCitizenID: function() { // 32 : BSTR GetHiCertTailCitizenID()
                var str = obj.ExecMethod("GetHiCertTailCitizenID");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetHiCertUniformOrganizationID: function() { // 33 : BSTR GetHiCertUniformOrganizationID()
                var str = obj.ExecMethod("GetHiCertUniformOrganizationID");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetHiCertCaName: function() { // 34 : BSTR GetHiCertCaName()
                var str = obj.ExecMethod("GetHiCertCaName");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetHiCertSubjectTypeCht: function() { // 35 : BSTR GetHiCertSubjectTypeCht()
                var str = obj.ExecMethod("GetHiCertSubjectTypeCht");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetHiCertSubjectTypeEng: function() { // 36 : BSTR GetHiCertSubjectTypeEng()
                var str = obj.ExecMethod("GetHiCertSubjectTypeEng");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetHiCertEntityOID: function() { // 37 : BSTR GetHiCertEntityOID()
                var str = obj.ExecMethod("GetHiCertEntityOID");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },

            //插拔卡API
            ICCardInsertCheck: function(dwTimeOut) { // 16 : long ICCardInsertCheck(long dwTimeOut)
                var str = obj.ExecMethod("ICCardInsertCheck") + obj.ExecParam(dwTimeOut);
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str));
                //if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },

            //台企銀
            IFXSign: function(sXMLData, sID, sSignedIDs, iFlags) { //
                var str = obj.ExecMethod("IFXSign") + obj.ExecParam(sXMLData, sID, sSignedIDs, iFlags);
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str));
            },
            GetIFXSignData: function() { //
                var str = obj.ExecMethod("GetIFXSignData") + obj.ExecParam();
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },

            //板信
            IFXVerify: function(strXmlSignature) { // long IFXVerify(LPCTSTR strXmlSignature);
                var str = obj.ExecMethod("IFXVerify") + obj.ExecParam(strXmlSignature);
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str));
            },

            //臺企
            SetEncoding: function(iFlag) { //
                var str = obj.ExecMethod("SetEncoding") + obj.ExecParam(iFlag);
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str));
            },
            SelectCertID: function(CertType, strId) { //
                var str = obj.ExecMethod("SelectCertID") + obj.ExecParam(CertType, strId);
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str));
            },
            GetPKCS10: function() { //
                var str = obj.ExecMethod("GetPKCS10") + obj.ExecParam();
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            getErrorCode: function() { // 舊 API
                var str = obj.ExecMethod("getErrorCode"); //
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str));
            },
            getErrorMsg: function() { // 舊 API
                var str = obj.ExecMethod("getErrorMsg");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            CreatePKCS10: function(commonName, keyBits, genKeyFlags) {
                var str = obj.ExecMethod("CreatePKCS10") + obj.ExecParam(commonName, keyBits, genKeyFlags);
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str));
            },
            GetHCAData: function() {
                var str = obj.ExecMethod("GetHCAData");
                if (pk11SessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            ReadHCAData: function() {
                var str = obj.ExecMethod("ReadHCAData");
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str));
            },
            SignPKCS7ForID: function(toSigndata) { // 24
                var str = obj.ExecMethod("SignPKCS7ForID") + obj.ExecParam(toSigndata);
                if (pk11SessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },

        }
    }
    window.addEventListener("beforeunload", obj.finalizeAgent);

    return obj;
}

// Add by TWCA for exposing to window.
window.pk11SessionToken = null;
window.initPk11AgentForChromeInIDPaaS = initPk11AgentForChrome;
